var $804735b3fcbe5a50$exports = {};
$804735b3fcbe5a50$exports = {
    "colorFormat": `\u{62A}\u{646}\u{633}\u{64A}\u{642} \u{627}\u{644}\u{644}\u{648}\u{646}`,
    "hex": `Hex`,
    "hsb": `HSB`,
    "hsl": `HSL`,
    "rgb": `RGB`
};


export {$804735b3fcbe5a50$exports as default};
//# sourceMappingURL=ar-AE.mjs.map
